<template>
  <v-form ref="form" autocomplete="off">
    <v-row>

      <v-col cols="12">
        <v-list>
          <show-field :value="form.branch.name" :label="$t('delivery.stock.labels.branch')" icon="store"/>
        </v-list>
      </v-col>

      <v-col cols="12">
        <v-data-table
            :items="form.items"
            :headers="headers"
            :items-per-page="50"
            :footer-props="{ itemsPerPageOptions: [5, 10, 25, 50, 100, -1] }"
        >

          <template v-slot:item.shortName="{item}">
            {{item.product.shortName}}
          </template>

          <template v-slot:item.product="{item}">
            <div class="d-flex flex-no-wrap justify-space-between align-center">

              <div>
                <v-avatar tile size="50px">
                  <v-img :src="item.product.image"></v-img>
                </v-avatar>
              </div>

              <div class="title text-left flex-grow-1 pl-3">
                <v-clamp autoresize :max-lines="1">
                 {{ item.product.name.charAt(0).toUpperCase() + item.product.name.toLowerCase().substring(1) }}
                </v-clamp>
              </div>
            </div>
          </template>

          <template v-slot:item.minimum="{item}">
            <v-text-field
                dense hide-details
                name="minimum"
                v-model.number="item.minimum"
                type="number"
                :error="hasInputErrors('minimum')"
                :error-messages="getInputErrors('minimum')"
                color="secondary"
                :rules="required"
            ></v-text-field>
          </template>

          <template v-slot:item.order="{item}">
            <v-text-field
                dense hide-details
                name="order"
                v-model.number="item.order"
                type="number"
                :error="hasInputErrors('order')"
                :error-messages="getInputErrors('order')"
                color="secondary"
                :rules="required"
            ></v-text-field>
          </template>

          <template v-slot:item.hide="{item}">
          <v-checkbox
              name="enable"
              v-model="item.hide"
              :error="hasInputErrors('hide')"
              :error-messages="getInputErrors('hide')"
              color="secondary"
          ></v-checkbox>
          </template>

        </v-data-table>
      </v-col>

    </v-row>
  </v-form>
</template>

<script>
import {InputErrorsByProps, RequiredRule} from '@dracul/common-frontend'

import ProductProvider from "@/modules/delivery/providers/ProductProvider";
import {ShowField} from '@dracul/common-frontend'
import VClamp from 'vue-clamp'

export default {
  name: "StockForm",
  mixins: [InputErrorsByProps, RequiredRule, VClamp],
  components: {
     ShowField
  },
  props: {
    value: {
      type: Object,
      required: true
    },
  },
  computed: {
    headers() {
      return [
        {text: this.$t('delivery.product.labels.shortName'), value: 'shortName', align: 'center'},
        {text: this.$t('delivery.stock.labels.product'), value: 'product', align: 'center'},
        {text: this.$t('delivery.stock.labels.quantity'), value: 'quantity', align: 'center'},
        {text: this.$t('delivery.stock.labels.minimum'), value: 'minimum', align: 'center', width:'100px'},
        {text: this.$t('delivery.stock.labels.order'), value: 'order', align: 'center', width:'100px'},
        {text: this.$t('delivery.stock.labels.hide'), value: 'hide', align: 'center'},
      ]
    },
    form: {
      get() {
        return this.value
      },
      set(val) {
        this.$emit('input', val)
      }
    }
  },
  watch: {
    form: {
      handler(newVal) {
        this.$emit('input', newVal)
      },
      deep: true
    }
  },
  mounted() {
   // this.fetchProducts()
  },
  methods: {
    validate() {
      return this.$refs.form.validate()
    },
    fetchProducts() {
      ProductProvider.fetchProduct()
          .then(r => {
            let products = r.data.fetchProduct

            let missingProducts = products.filter(p => !this.form.items.some(i => i.product === p.id))

            for (let p of missingProducts) {
              this.form.items.push(
                  {
                    product: p,
                    quantity: 0,
                    order: null,
                    hide: false
                  })
            }

          })
    }
  },
  data() {
    return {}
  }
}
</script>

<style scoped>

</style>

